<template>
  <div class="profile-tab-wrapper">
    <div class="profile-tab">
      <div v-for="(item, index) in tabs" :key="index">
        <button
          type="button"
          :class="`tab-item ${index == activeTab && 'tab-active'}`"
          @click="handleChangeTab(index)"
        >
          {{ item }}
        </button>
      </div>
    </div>

    <div class="custom-switch">
      <h6>
        네트워킹 노출 ON/OF
      </h6>
      <label class="switch">
        <input type="checkbox" v-model="checked" />
        <span class="slider round"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabInformation",
  props: {
    networkingOn: Boolean,
    tabs: Array,
    activeTab: Number,
    handleChangeTab: Function,
  },
  computed: {
    checked: {
      set(val) {
        this.$emit("update:networkingOn", val);
      },
      get() {
        return this.networkingOn;
      },
    },
  },
};
</script>
